import { render, staticRenderFns } from "./OverviewDetailsItem.vue?vue&type=template&id=59e218bc&"
import script from "./OverviewDetailsItem.vue?vue&type=script&lang=js&"
export * from "./OverviewDetailsItem.vue?vue&type=script&lang=js&"
import style0 from "./OverviewDetailsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports